<div class="container" *ngrxLet="country$ as country">
    <span *ngIf="country === undefined">{{ "dtmUi.countryDisplay.noCountryMessage" | transloco }}</span>
    <span *ngIf="country === null">{{ "dtmUi.countryDisplay.invalidCountryMessage" | transloco }}</span>
    <div class="country-item-container" *ngIf="country">
        <dtm-ui-country-flag-display [country]="country.alpha3Code"></dtm-ui-country-flag-display>
        <span>{{ country.displayName }}</span>
    </div>
</div>
